import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { AxonAlertAction } from './axon-alerts.model';
import { AxonDeviceModel } from './axon-device.model';
import { AxonNotificationModel } from './axon-notification.model';

export class AxonUsherAlertModel extends SnModel {
  @Expose()
  public device: AxonDeviceModel;

  @Expose()
  public message: string;

  @Expose()
  public notification: AxonNotificationModel;

  @Expose()
  public ownerName: string;

  // Partially implemented fields of new alert contract
  @Expose()
  public actions: AxonAlertAction[];

  @Expose()
  public styles: {
    color?: string;
    icon?: string;
    sound?: string;
  } = {};

  @Expose()
  public momentCreated?: string;

  get messageTranslation(): string {
    if (this.message) {
      return this.message;
    }
    
    return this._messages[this.notification.category] || this.notification.category;
  }

  get filteredMessageAnalyticData(): any {
    return {
      device: {
        deviceId: this.device.deviceId,
        serial: this.device.serial,
        signalStrength: this.device.signalStrength,
        signalType: this.device.signalType,
      },
      message: this.message,
      notification: {
        category: this.notification.category,
        type: this.notification.type,
        timeOccurred: this.notification.timeOccurred,
        notificationReceived: this.notification.notificationReceivedTime,
        level: this.notification.level,
        deviceId: this.notification.deviceId,
        deviceModel: this.notification.deviceModel,
        deviceType: this.notification.deviceType,
      },
    };
  }

  private _messages = {
    WatchMeActivate: 'Watch Me Requested',
    Holster: 'Weapon Drawn',
    CewArc: 'TASER Weapon Arced',
    CewArm: 'TASER Weapon Armed',
    CewTrigger: 'TASER Weapon Trigger Pulled',
    CewSwitchEnergize: 'TASER Weapon Energized due to Switch',
    CewTriggerEnergize: 'TASER Weapon Energized due to Trigger',
    CewRaised: 'TASER Weapon Raised while Armed',
    CewUnholstered: 'TASER Weapon Unholstered',
    CewWarning: 'TASER Weapon Warning Alerted',
    Gunshot: 'Gunshot',
    VehicleAcceleration: 'Vehicle Impact',
    AsuWeaponRack: 'Weapon Rack',
    AsuWeaponRack1: 'Weapon Rack',
    AsuWeaponRack2: 'Weapon Rack',
    AsuLightbar: 'Light Bar',
    AsuSiren: 'Siren',
    VehicleVelocity: 'Vehicle Speed Exceeded 95 MPH',
    AsuLightbarCode1: 'Light Bar Code 1',
    AsuLightbarCode2: 'Light Bar Code 2',
    AsuLightbarCode3: 'Light Bar Code 3',
    AsuRearDoorDriver: 'Rear Door Driver Side',
    AsuRearDoorPassenger: 'Rear Door Passenger Side',
  };

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
